import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private currentTheme: 'chill' | 'quote-devil' = 'chill';

  setTheme(theme: 'chill' | 'quote-devil') {
    const body = document.body;
    body.classList.remove('empresa-a', 'empresa-b');
    body.classList.add(theme);
    this.currentTheme = theme;
  }

  getCurrentTheme() {
    return this.currentTheme;
  }
}
